import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-itinerary-explorer-page',
  templateUrl: './itinerary-explorer-page.component.html',
  styleUrls: ['./itinerary-explorer-page.component.css'],
})
export class ItineraryExplorerPageComponent implements OnInit {
  userdata?: UserData;
  shipname = '';
  validsession: boolean | undefined;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;
  nonIOSdevice: boolean = false;

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private EmployeeLoginService: EmployeeloginService
  ) {
    this.getos();
    // this.validsession = this.sesssionvalidator.validate();
    // if (this.validsession) {
    //   this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    //   this.shipname = this.userdata?.ShipName!;
    // } else {
    //   this.router.navigate(['/login']);
    // }
  }
  ngOnInit() {
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/login']);
      }
    }
  }
  getos() {
    // alert('UserAgent::::' + navigator.userAgent);
    // alert('Platform::::' + navigator.platform);
    // alert('Vendor::::' + navigator.vendor);
    if (
      navigator.userAgent.indexOf('Mac') === -1 &&
      navigator.userAgent.indexOf('iPhone') === -1 &&
      navigator.userAgent.indexOf('iPad') === -1
    ) {
      this.nonIOSdevice = true;
    } else this.nonIOSdevice = false;
  }
  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }
}
